<template>
  <el-tooltip class="item" effect="dark" :content="message" placement="top-start">
    <badge type="info"><i class="fa fa-info-circle"></i></badge>
  </el-tooltip>
</template>

<script>
  import { Tooltip } from 'element-ui'
  import Badge from './Badge'
  export default {
		name: "MoreInfo",
    props: {
		  message: {
		    type: String,
        required: true
      }
    },
    components: {
      [Tooltip.name]: Tooltip,
      [Badge.name]: Badge
    }
	}
</script>

<style scoped></style>
